import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { cascadeDataAtom } from './atoms'
import { OpenJsonButton } from '../../utility/OpenJsonButton'
import { DownloadJsonButton } from '../../utility/DownloadJsonButton'
import { SummaryTable } from '../../SummaryTable'
import { calculateCascadeSummaryRows } from './cascade_utils'

export function CascadeSummary() {
  const cascadeData = useAtomValue(cascadeDataAtom)
  const summaryRows = calculateCascadeSummaryRows(cascadeData)

  if (!cascadeData) {
    return null
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="subtitle1">
          {cascadeData.mode === 'Roll Up'
            ? 'Rolled up standards summary'
            : 'Rolled down standards summary'}
        </Typography>
        <OpenJsonButton
          data={cascadeData}
          disabled={false}
          buttonText="Open JSON"
        />
        <DownloadJsonButton
          data={cascadeData}
          filename={`cascade_data_${cascadeData.tree_id}_${cascadeData.version_id}.json`}
        />
      </Box>
      <SummaryTable rows={summaryRows} />
    </Box>
  )
}
